import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { DetailsForm } from "@/components/portal/details-form";
import { portalDetailsQuery } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/details")({
  loader: ({ context }) => context.queryClient.ensureQueryData(portalDetailsQuery),
  component: PortalDetailsPage,
});

function PortalDetailsPage() {
  const { data } = useQuery(portalDetailsQuery);
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">My details</h1>
        <p className="text-muted-foreground text-sm">
          The information your HR team has on file. It's read-only — if something is wrong, request
          a correction and HR will update it.
        </p>
      </div>
      <DetailsForm fields={data ?? []} />
    </div>
  );
}
